/* eslint-disable */
// @generated by protobuf-ts 2.8.2 with parameter generate_dependencies,add_pb_suffix,use_proto_field_name,ts_nocheck,eslint_disable
// @generated from protobuf file "brandguard.video.proto" (package "brandguard.video", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { VideoKernelSetting } from "./brandguard.kernel_pb";
import { KernelMetadata } from "./brandguard.kernel_pb";
import { Keyset } from "./meta.search_pb";
import { FloatRange } from "./meta.search_pb";
import { DateRange } from "./meta.search_pb";
import { Prediction } from "./brandguard.approval_pb";
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoEvent
 */
export interface VideoEvent {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string account_id = 2 [json_name = "account_id"];
     */
    account_id: string;
    /**
     * @generated from protobuf field: string brand_id = 3 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: brandguard.approval.Prediction approved = 4;
     */
    approved: Prediction;
    /**
     * @generated from protobuf field: brandguard.approval.Prediction observation = 5;
     */
    observation: Prediction;
    /**
     * @generated from protobuf field: string queue = 6;
     */
    queue: string;
    /**
     * @generated from protobuf field: double confidence = 1000;
     */
    confidence: number;
    /**
     * @generated from protobuf field: double video_brand_uniqueness = 1004 [json_name = "video_brand_uniqueness"];
     */
    video_brand_uniqueness: number;
    /**
     * @generated from protobuf field: double video_brand_voice = 1005 [json_name = "video_brand_voice"];
     */
    video_brand_voice: number;
    /**
     * @generated from protobuf field: double video_sexually_explicit = 1006 [json_name = "video_sexually_explicit"];
     */
    video_sexually_explicit: number;
    /**
     * @generated from protobuf field: double video_quality_general = 1007 [json_name = "video_quality_general"];
     */
    video_quality_general: number;
    /**
     * @generated from protobuf field: double video_violence = 1008 [json_name = "video_violence"];
     */
    video_violence: number;
    /**
     * @generated from protobuf field: double video_logo_detection = 1009 [json_name = "video_logo_detection"];
     */
    video_logo_detection: number;
    /**
     * @generated from protobuf field: double video_font_detection = 1010 [json_name = "video_font_detection"];
     */
    video_font_detection: number;
    /**
     * @generated from protobuf field: double video_background_colors = 1011 [json_name = "video_background_colors"];
     */
    video_background_colors: number;
    /**
     * @generated from protobuf field: int64 video_lookandfeel_checks = 1012 [json_name = "video_lookandfeel_checks"];
     */
    video_lookandfeel_checks: bigint;
    /**
     * @generated from protobuf field: int64 video_lookandfeel_violations = 1013 [json_name = "video_lookandfeel_violations"];
     */
    video_lookandfeel_violations: bigint;
    /**
     * @generated from protobuf field: double video_lookandfeel_conformance = 1014 [json_name = "video_lookandfeel_conformance"];
     */
    video_lookandfeel_conformance: number;
    /**
     * @generated from protobuf field: string updated_at = 1015 [json_name = "updated_at"];
     */
    updated_at: string;
    /**
     * @generated from protobuf field: double artifact_score = 1016 [json_name = "artifact_score"];
     */
    artifact_score: number;
    /**
     * @generated from protobuf field: string artifact_match_description = 1017 [json_name = "artifact_match_description"];
     */
    artifact_match_description: string;
    /**
     * @generated from protobuf field: string artifact_match_training_id = 1018 [json_name = "artifact_match_training_id"];
     */
    artifact_match_training_id: string;
    /**
     * @generated from protobuf field: double duration_seconds = 1019 [json_name = "duration_seconds"];
     */
    duration_seconds: number;
    /**
     * @generated from protobuf field: double video_ai_generated = 1020 [json_name = "video_ai_generated"];
     */
    video_ai_generated: number;
    /**
     * @generated from protobuf field: string video_ai_generated_explanation = 1021 [json_name = "video_ai_generated_explanation"];
     */
    video_ai_generated_explanation: string;
    /**
     * @generated from protobuf field: string video_quality_general_explanation = 1022 [json_name = "video_quality_general_explanation"];
     */
    video_quality_general_explanation: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoMedia
 */
export interface VideoMedia {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string account_id = 2 [json_name = "account_id"];
     */
    account_id: string;
    /**
     * @generated from protobuf field: string brand_id = 3 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: string uploaded_by = 4 [json_name = "uploaded_by"];
     */
    uploaded_by: string;
    /**
     * @generated from protobuf field: string md5 = 5;
     */
    md5: string;
    /**
     * @generated from protobuf field: string mimetype = 6;
     */
    mimetype: string;
    /**
     * @generated from protobuf field: string mimetype_md5 = 7 [json_name = "mimetype_md5"];
     */
    mimetype_md5: string;
    /**
     * @generated from protobuf field: string created_at = 8 [json_name = "created_at"];
     */
    created_at: string;
    /**
     * @generated from protobuf field: string updated_at = 9 [json_name = "updated_at"];
     */
    updated_at: string;
    /**
     * @generated from protobuf field: string tombstoned_at = 10 [json_name = "tombstoned_at"];
     */
    tombstoned_at: string;
    /**
     * @generated from protobuf field: string scored_at = 11 [json_name = "scored_at"];
     */
    scored_at: string;
    /**
     * @generated from protobuf field: string description = 12;
     */
    description: string;
    /**
     * @generated from protobuf field: string reviewed_by = 13 [json_name = "reviewed_by"];
     */
    reviewed_by: string;
    /**
     * @generated from protobuf field: double duration_seconds = 14 [json_name = "duration_seconds"];
     */
    duration_seconds: number;
    /**
     * @generated from protobuf field: string ancestor_id = 15 [json_name = "ancestor_id"];
     */
    ancestor_id: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoUploadRequest
 */
export interface VideoUploadRequest {
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoUploadResponse
 */
export interface VideoUploadResponse {
    /**
     * @generated from protobuf field: brandguard.video.VideoMedia media = 1;
     */
    media?: VideoMedia;
    /**
     * @generated from protobuf field: brandguard.video.VideoEvent event = 2;
     */
    event?: VideoEvent;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoMediaUploadRequest
 */
export interface VideoMediaUploadRequest {
    /**
     * @generated from protobuf field: repeated string md5s = 1 [json_name = "md5s"];
     */
    md5s: string[];
    /**
     * @generated from protobuf field: brandguard.approval.Prediction observation = 2;
     */
    observation: Prediction;
    /**
     * @generated from protobuf field: int64 delay = 3;
     */
    delay: bigint;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoMediaUploadResponse
 */
export interface VideoMediaUploadResponse {
    /**
     * @generated from protobuf field: repeated brandguard.video.VideoUploadResponse items = 1;
     */
    items: VideoUploadResponse[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoSearchRequest
 */
export interface VideoSearchRequest {
    /**
     * @generated from protobuf field: int64 offset = 1;
     */
    offset: bigint;
    /**
     * @generated from protobuf field: repeated string queues = 2;
     */
    queues: string[];
    /**
     * @deprecated
     * @generated from protobuf field: string deprecated_uploaded_by = 3 [deprecated = true, json_name = "uploaded_by"];
     */
    deprecated_uploaded_by: string;
    /**
     * @generated from protobuf field: string brand_id = 4 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: meta.DateRange created = 5;
     */
    created?: DateRange;
    /**
     * @generated from protobuf field: uint64 limit = 6;
     */
    limit: bigint;
    /**
     * @generated from protobuf field: repeated brandguard.approval.Prediction observation = 7;
     */
    observation: Prediction[];
    /**
     * @generated from protobuf field: repeated brandguard.approval.Prediction approved = 8;
     */
    approved: Prediction[];
    /**
     * @generated from protobuf field: meta.FloatRange confidence = 9;
     */
    confidence?: FloatRange;
    /**
     * @generated from protobuf field: repeated string uploaded_by = 10 [json_name = "uploaders"];
     */
    uploaded_by: string[];
    /**
     * @generated from protobuf field: meta.Keyset before = 11;
     */
    before?: Keyset; // only results older than this position
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoSearchResponseItem
 */
export interface VideoSearchResponseItem {
    /**
     * @generated from protobuf field: brandguard.video.VideoMedia media = 1;
     */
    media?: VideoMedia;
    /**
     * @generated from protobuf field: brandguard.video.VideoEvent event = 2;
     */
    event?: VideoEvent;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoSearchResponse
 */
export interface VideoSearchResponse {
    /**
     * @generated from protobuf field: repeated brandguard.video.VideoSearchResponseItem items = 1;
     */
    items: VideoSearchResponseItem[];
    /**
     * @generated from protobuf field: brandguard.video.VideoSearchRequest next = 2;
     */
    next?: VideoSearchRequest;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoFindRequest
 */
export interface VideoFindRequest {
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoFindResponse
 */
export interface VideoFindResponse {
    /**
     * @generated from protobuf field: brandguard.video.VideoMedia media = 1;
     */
    media?: VideoMedia;
    /**
     * @generated from protobuf field: brandguard.video.VideoEvent event = 2;
     */
    event?: VideoEvent;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoScoreRequest
 */
export interface VideoScoreRequest {
}
/**
 * @generated from protobuf message brandguard.video.VideoScoreResponse
 */
export interface VideoScoreResponse {
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoPatchRequest
 */
export interface VideoPatchRequest {
    /**
     * @generated from protobuf field: brandguard.video.VideoMedia media = 1;
     */
    media?: VideoMedia;
    /**
     * @generated from protobuf field: brandguard.video.VideoEvent event = 2;
     */
    event?: VideoEvent;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoPatchResponse
 */
export interface VideoPatchResponse {
    /**
     * @generated from protobuf field: brandguard.video.VideoMedia media = 1;
     */
    media?: VideoMedia;
    /**
     * @generated from protobuf field: brandguard.video.VideoEvent event = 2;
     */
    event?: VideoEvent;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoTrainRequest
 */
export interface VideoTrainRequest {
    /**
     * @generated from protobuf field: int64 ago = 1;
     */
    ago: bigint;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoTrainResponse
 */
export interface VideoTrainResponse {
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoKernelSearchRequest
 */
export interface VideoKernelSearchRequest {
    /**
     * @generated from protobuf field: int64 offset = 1;
     */
    offset: bigint;
    /**
     * @generated from protobuf field: string brand_id = 4 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: meta.DateRange created = 5;
     */
    created?: DateRange;
    /**
     * @generated from protobuf field: uint64 limit = 6;
     */
    limit: bigint;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoKernelSearchResponse
 */
export interface VideoKernelSearchResponse {
    /**
     * @generated from protobuf field: repeated brandguard.kernel.KernelMetadata items = 1;
     */
    items: KernelMetadata[];
    /**
     * @generated from protobuf field: brandguard.video.VideoKernelSearchRequest next = 2;
     */
    next?: VideoKernelSearchRequest;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoKernelFindRequest
 */
export interface VideoKernelFindRequest {
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoKernelFindResponse
 */
export interface VideoKernelFindResponse {
    /**
     * @generated from protobuf field: brandguard.kernel.KernelMetadata kernel = 1;
     */
    kernel?: KernelMetadata;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoKernelSettingsCreateRequest
 */
export interface VideoKernelSettingsCreateRequest {
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelSetting settings = 1;
     */
    settings?: VideoKernelSetting;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoKernelSettingsCreateResponse
 */
export interface VideoKernelSettingsCreateResponse {
    /**
     * @generated from protobuf field: brandguard.kernel.KernelMetadata kernel = 1;
     */
    kernel?: KernelMetadata;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoKernelSettingsRequest
 */
export interface VideoKernelSettingsRequest {
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoKernelSettingsResponse
 */
export interface VideoKernelSettingsResponse {
    /**
     * @generated from protobuf field: brandguard.kernel.VideoKernelSetting settings = 1;
     */
    settings?: VideoKernelSetting;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoRescoreRequest
 */
export interface VideoRescoreRequest {
    /**
     * @generated from protobuf field: int64 delay = 1;
     */
    delay: bigint;
    /**
     * @generated from protobuf field: meta.DateRange window = 2;
     */
    window?: DateRange;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoRescoreResponse
 */
export interface VideoRescoreResponse {
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoVersionHistoryRequest
 */
export interface VideoVersionHistoryRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.video.VideoVersionHistoryResponse
 */
export interface VideoVersionHistoryResponse {
    /**
     * @generated from protobuf field: repeated brandguard.video.VideoSearchResponseItem versions = 1;
     */
    versions: VideoSearchResponseItem[];
}
// @generated message type with reflection information, may provide speed optimized methods
class VideoEvent$Type extends MessageType<VideoEvent> {
    constructor() {
        super("brandguard.video.VideoEvent", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "account_id", kind: "scalar", localName: "account_id", jsonName: "account_id", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "approved", kind: "enum", T: () => ["brandguard.approval.Prediction", Prediction] },
            { no: 5, name: "observation", kind: "enum", T: () => ["brandguard.approval.Prediction", Prediction] },
            { no: 6, name: "queue", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 1000, name: "confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1004, name: "video_brand_uniqueness", kind: "scalar", localName: "video_brand_uniqueness", jsonName: "video_brand_uniqueness", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1005, name: "video_brand_voice", kind: "scalar", localName: "video_brand_voice", jsonName: "video_brand_voice", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1006, name: "video_sexually_explicit", kind: "scalar", localName: "video_sexually_explicit", jsonName: "video_sexually_explicit", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1007, name: "video_quality_general", kind: "scalar", localName: "video_quality_general", jsonName: "video_quality_general", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1008, name: "video_violence", kind: "scalar", localName: "video_violence", jsonName: "video_violence", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1009, name: "video_logo_detection", kind: "scalar", localName: "video_logo_detection", jsonName: "video_logo_detection", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1010, name: "video_font_detection", kind: "scalar", localName: "video_font_detection", jsonName: "video_font_detection", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1011, name: "video_background_colors", kind: "scalar", localName: "video_background_colors", jsonName: "video_background_colors", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1012, name: "video_lookandfeel_checks", kind: "scalar", localName: "video_lookandfeel_checks", jsonName: "video_lookandfeel_checks", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 1013, name: "video_lookandfeel_violations", kind: "scalar", localName: "video_lookandfeel_violations", jsonName: "video_lookandfeel_violations", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 1014, name: "video_lookandfeel_conformance", kind: "scalar", localName: "video_lookandfeel_conformance", jsonName: "video_lookandfeel_conformance", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1015, name: "updated_at", kind: "scalar", localName: "updated_at", jsonName: "updated_at", T: 9 /*ScalarType.STRING*/ },
            { no: 1016, name: "artifact_score", kind: "scalar", localName: "artifact_score", jsonName: "artifact_score", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1017, name: "artifact_match_description", kind: "scalar", localName: "artifact_match_description", jsonName: "artifact_match_description", T: 9 /*ScalarType.STRING*/ },
            { no: 1018, name: "artifact_match_training_id", kind: "scalar", localName: "artifact_match_training_id", jsonName: "artifact_match_training_id", T: 9 /*ScalarType.STRING*/ },
            { no: 1019, name: "duration_seconds", kind: "scalar", localName: "duration_seconds", jsonName: "duration_seconds", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1020, name: "video_ai_generated", kind: "scalar", localName: "video_ai_generated", jsonName: "video_ai_generated", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1021, name: "video_ai_generated_explanation", kind: "scalar", localName: "video_ai_generated_explanation", jsonName: "video_ai_generated_explanation", T: 9 /*ScalarType.STRING*/ },
            { no: 1022, name: "video_quality_general_explanation", kind: "scalar", localName: "video_quality_general_explanation", jsonName: "video_quality_general_explanation", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VideoEvent>): VideoEvent {
        const message = { id: "", account_id: "", brand_id: "", approved: 0, observation: 0, queue: "", confidence: 0, video_brand_uniqueness: 0, video_brand_voice: 0, video_sexually_explicit: 0, video_quality_general: 0, video_violence: 0, video_logo_detection: 0, video_font_detection: 0, video_background_colors: 0, video_lookandfeel_checks: 0n, video_lookandfeel_violations: 0n, video_lookandfeel_conformance: 0, updated_at: "", artifact_score: 0, artifact_match_description: "", artifact_match_training_id: "", duration_seconds: 0, video_ai_generated: 0, video_ai_generated_explanation: "", video_quality_general_explanation: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoEvent): VideoEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string account_id = 2 [json_name = "account_id"];*/ 2:
                    message.account_id = reader.string();
                    break;
                case /* string brand_id = 3 [json_name = "brand_id"];*/ 3:
                    message.brand_id = reader.string();
                    break;
                case /* brandguard.approval.Prediction approved */ 4:
                    message.approved = reader.int32();
                    break;
                case /* brandguard.approval.Prediction observation */ 5:
                    message.observation = reader.int32();
                    break;
                case /* string queue */ 6:
                    message.queue = reader.string();
                    break;
                case /* double confidence */ 1000:
                    message.confidence = reader.double();
                    break;
                case /* double video_brand_uniqueness = 1004 [json_name = "video_brand_uniqueness"];*/ 1004:
                    message.video_brand_uniqueness = reader.double();
                    break;
                case /* double video_brand_voice = 1005 [json_name = "video_brand_voice"];*/ 1005:
                    message.video_brand_voice = reader.double();
                    break;
                case /* double video_sexually_explicit = 1006 [json_name = "video_sexually_explicit"];*/ 1006:
                    message.video_sexually_explicit = reader.double();
                    break;
                case /* double video_quality_general = 1007 [json_name = "video_quality_general"];*/ 1007:
                    message.video_quality_general = reader.double();
                    break;
                case /* double video_violence = 1008 [json_name = "video_violence"];*/ 1008:
                    message.video_violence = reader.double();
                    break;
                case /* double video_logo_detection = 1009 [json_name = "video_logo_detection"];*/ 1009:
                    message.video_logo_detection = reader.double();
                    break;
                case /* double video_font_detection = 1010 [json_name = "video_font_detection"];*/ 1010:
                    message.video_font_detection = reader.double();
                    break;
                case /* double video_background_colors = 1011 [json_name = "video_background_colors"];*/ 1011:
                    message.video_background_colors = reader.double();
                    break;
                case /* int64 video_lookandfeel_checks = 1012 [json_name = "video_lookandfeel_checks"];*/ 1012:
                    message.video_lookandfeel_checks = reader.int64().toBigInt();
                    break;
                case /* int64 video_lookandfeel_violations = 1013 [json_name = "video_lookandfeel_violations"];*/ 1013:
                    message.video_lookandfeel_violations = reader.int64().toBigInt();
                    break;
                case /* double video_lookandfeel_conformance = 1014 [json_name = "video_lookandfeel_conformance"];*/ 1014:
                    message.video_lookandfeel_conformance = reader.double();
                    break;
                case /* string updated_at = 1015 [json_name = "updated_at"];*/ 1015:
                    message.updated_at = reader.string();
                    break;
                case /* double artifact_score = 1016 [json_name = "artifact_score"];*/ 1016:
                    message.artifact_score = reader.double();
                    break;
                case /* string artifact_match_description = 1017 [json_name = "artifact_match_description"];*/ 1017:
                    message.artifact_match_description = reader.string();
                    break;
                case /* string artifact_match_training_id = 1018 [json_name = "artifact_match_training_id"];*/ 1018:
                    message.artifact_match_training_id = reader.string();
                    break;
                case /* double duration_seconds = 1019 [json_name = "duration_seconds"];*/ 1019:
                    message.duration_seconds = reader.double();
                    break;
                case /* double video_ai_generated = 1020 [json_name = "video_ai_generated"];*/ 1020:
                    message.video_ai_generated = reader.double();
                    break;
                case /* string video_ai_generated_explanation = 1021 [json_name = "video_ai_generated_explanation"];*/ 1021:
                    message.video_ai_generated_explanation = reader.string();
                    break;
                case /* string video_quality_general_explanation = 1022 [json_name = "video_quality_general_explanation"];*/ 1022:
                    message.video_quality_general_explanation = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string account_id = 2 [json_name = "account_id"]; */
        if (message.account_id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.account_id);
        /* string brand_id = 3 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.brand_id);
        /* brandguard.approval.Prediction approved = 4; */
        if (message.approved !== 0)
            writer.tag(4, WireType.Varint).int32(message.approved);
        /* brandguard.approval.Prediction observation = 5; */
        if (message.observation !== 0)
            writer.tag(5, WireType.Varint).int32(message.observation);
        /* string queue = 6; */
        if (message.queue !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.queue);
        /* double confidence = 1000; */
        if (message.confidence !== 0)
            writer.tag(1000, WireType.Bit64).double(message.confidence);
        /* double video_brand_uniqueness = 1004 [json_name = "video_brand_uniqueness"]; */
        if (message.video_brand_uniqueness !== 0)
            writer.tag(1004, WireType.Bit64).double(message.video_brand_uniqueness);
        /* double video_brand_voice = 1005 [json_name = "video_brand_voice"]; */
        if (message.video_brand_voice !== 0)
            writer.tag(1005, WireType.Bit64).double(message.video_brand_voice);
        /* double video_sexually_explicit = 1006 [json_name = "video_sexually_explicit"]; */
        if (message.video_sexually_explicit !== 0)
            writer.tag(1006, WireType.Bit64).double(message.video_sexually_explicit);
        /* double video_quality_general = 1007 [json_name = "video_quality_general"]; */
        if (message.video_quality_general !== 0)
            writer.tag(1007, WireType.Bit64).double(message.video_quality_general);
        /* double video_violence = 1008 [json_name = "video_violence"]; */
        if (message.video_violence !== 0)
            writer.tag(1008, WireType.Bit64).double(message.video_violence);
        /* double video_logo_detection = 1009 [json_name = "video_logo_detection"]; */
        if (message.video_logo_detection !== 0)
            writer.tag(1009, WireType.Bit64).double(message.video_logo_detection);
        /* double video_font_detection = 1010 [json_name = "video_font_detection"]; */
        if (message.video_font_detection !== 0)
            writer.tag(1010, WireType.Bit64).double(message.video_font_detection);
        /* double video_background_colors = 1011 [json_name = "video_background_colors"]; */
        if (message.video_background_colors !== 0)
            writer.tag(1011, WireType.Bit64).double(message.video_background_colors);
        /* int64 video_lookandfeel_checks = 1012 [json_name = "video_lookandfeel_checks"]; */
        if (message.video_lookandfeel_checks !== 0n)
            writer.tag(1012, WireType.Varint).int64(message.video_lookandfeel_checks);
        /* int64 video_lookandfeel_violations = 1013 [json_name = "video_lookandfeel_violations"]; */
        if (message.video_lookandfeel_violations !== 0n)
            writer.tag(1013, WireType.Varint).int64(message.video_lookandfeel_violations);
        /* double video_lookandfeel_conformance = 1014 [json_name = "video_lookandfeel_conformance"]; */
        if (message.video_lookandfeel_conformance !== 0)
            writer.tag(1014, WireType.Bit64).double(message.video_lookandfeel_conformance);
        /* string updated_at = 1015 [json_name = "updated_at"]; */
        if (message.updated_at !== "")
            writer.tag(1015, WireType.LengthDelimited).string(message.updated_at);
        /* double artifact_score = 1016 [json_name = "artifact_score"]; */
        if (message.artifact_score !== 0)
            writer.tag(1016, WireType.Bit64).double(message.artifact_score);
        /* string artifact_match_description = 1017 [json_name = "artifact_match_description"]; */
        if (message.artifact_match_description !== "")
            writer.tag(1017, WireType.LengthDelimited).string(message.artifact_match_description);
        /* string artifact_match_training_id = 1018 [json_name = "artifact_match_training_id"]; */
        if (message.artifact_match_training_id !== "")
            writer.tag(1018, WireType.LengthDelimited).string(message.artifact_match_training_id);
        /* double duration_seconds = 1019 [json_name = "duration_seconds"]; */
        if (message.duration_seconds !== 0)
            writer.tag(1019, WireType.Bit64).double(message.duration_seconds);
        /* double video_ai_generated = 1020 [json_name = "video_ai_generated"]; */
        if (message.video_ai_generated !== 0)
            writer.tag(1020, WireType.Bit64).double(message.video_ai_generated);
        /* string video_ai_generated_explanation = 1021 [json_name = "video_ai_generated_explanation"]; */
        if (message.video_ai_generated_explanation !== "")
            writer.tag(1021, WireType.LengthDelimited).string(message.video_ai_generated_explanation);
        /* string video_quality_general_explanation = 1022 [json_name = "video_quality_general_explanation"]; */
        if (message.video_quality_general_explanation !== "")
            writer.tag(1022, WireType.LengthDelimited).string(message.video_quality_general_explanation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoEvent
 */
export const VideoEvent = new VideoEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoMedia$Type extends MessageType<VideoMedia> {
    constructor() {
        super("brandguard.video.VideoMedia", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "account_id", kind: "scalar", localName: "account_id", jsonName: "account_id", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "uploaded_by", kind: "scalar", localName: "uploaded_by", jsonName: "uploaded_by", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "md5", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "mimetype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "mimetype_md5", kind: "scalar", localName: "mimetype_md5", jsonName: "mimetype_md5", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_at", kind: "scalar", localName: "created_at", jsonName: "created_at", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "updated_at", kind: "scalar", localName: "updated_at", jsonName: "updated_at", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "tombstoned_at", kind: "scalar", localName: "tombstoned_at", jsonName: "tombstoned_at", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "scored_at", kind: "scalar", localName: "scored_at", jsonName: "scored_at", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "reviewed_by", kind: "scalar", localName: "reviewed_by", jsonName: "reviewed_by", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "duration_seconds", kind: "scalar", localName: "duration_seconds", jsonName: "duration_seconds", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "ancestor_id", kind: "scalar", localName: "ancestor_id", jsonName: "ancestor_id", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VideoMedia>): VideoMedia {
        const message = { id: "", account_id: "", brand_id: "", uploaded_by: "", md5: "", mimetype: "", mimetype_md5: "", created_at: "", updated_at: "", tombstoned_at: "", scored_at: "", description: "", reviewed_by: "", duration_seconds: 0, ancestor_id: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoMedia>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoMedia): VideoMedia {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string account_id = 2 [json_name = "account_id"];*/ 2:
                    message.account_id = reader.string();
                    break;
                case /* string brand_id = 3 [json_name = "brand_id"];*/ 3:
                    message.brand_id = reader.string();
                    break;
                case /* string uploaded_by = 4 [json_name = "uploaded_by"];*/ 4:
                    message.uploaded_by = reader.string();
                    break;
                case /* string md5 */ 5:
                    message.md5 = reader.string();
                    break;
                case /* string mimetype */ 6:
                    message.mimetype = reader.string();
                    break;
                case /* string mimetype_md5 = 7 [json_name = "mimetype_md5"];*/ 7:
                    message.mimetype_md5 = reader.string();
                    break;
                case /* string created_at = 8 [json_name = "created_at"];*/ 8:
                    message.created_at = reader.string();
                    break;
                case /* string updated_at = 9 [json_name = "updated_at"];*/ 9:
                    message.updated_at = reader.string();
                    break;
                case /* string tombstoned_at = 10 [json_name = "tombstoned_at"];*/ 10:
                    message.tombstoned_at = reader.string();
                    break;
                case /* string scored_at = 11 [json_name = "scored_at"];*/ 11:
                    message.scored_at = reader.string();
                    break;
                case /* string description */ 12:
                    message.description = reader.string();
                    break;
                case /* string reviewed_by = 13 [json_name = "reviewed_by"];*/ 13:
                    message.reviewed_by = reader.string();
                    break;
                case /* double duration_seconds = 14 [json_name = "duration_seconds"];*/ 14:
                    message.duration_seconds = reader.double();
                    break;
                case /* string ancestor_id = 15 [json_name = "ancestor_id"];*/ 15:
                    message.ancestor_id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoMedia, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string account_id = 2 [json_name = "account_id"]; */
        if (message.account_id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.account_id);
        /* string brand_id = 3 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.brand_id);
        /* string uploaded_by = 4 [json_name = "uploaded_by"]; */
        if (message.uploaded_by !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.uploaded_by);
        /* string md5 = 5; */
        if (message.md5 !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.md5);
        /* string mimetype = 6; */
        if (message.mimetype !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.mimetype);
        /* string mimetype_md5 = 7 [json_name = "mimetype_md5"]; */
        if (message.mimetype_md5 !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.mimetype_md5);
        /* string created_at = 8 [json_name = "created_at"]; */
        if (message.created_at !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.created_at);
        /* string updated_at = 9 [json_name = "updated_at"]; */
        if (message.updated_at !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.updated_at);
        /* string tombstoned_at = 10 [json_name = "tombstoned_at"]; */
        if (message.tombstoned_at !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.tombstoned_at);
        /* string scored_at = 11 [json_name = "scored_at"]; */
        if (message.scored_at !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.scored_at);
        /* string description = 12; */
        if (message.description !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.description);
        /* string reviewed_by = 13 [json_name = "reviewed_by"]; */
        if (message.reviewed_by !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.reviewed_by);
        /* double duration_seconds = 14 [json_name = "duration_seconds"]; */
        if (message.duration_seconds !== 0)
            writer.tag(14, WireType.Bit64).double(message.duration_seconds);
        /* string ancestor_id = 15 [json_name = "ancestor_id"]; */
        if (message.ancestor_id !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.ancestor_id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoMedia
 */
export const VideoMedia = new VideoMedia$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoUploadRequest$Type extends MessageType<VideoUploadRequest> {
    constructor() {
        super("brandguard.video.VideoUploadRequest", []);
    }
    create(value?: PartialMessage<VideoUploadRequest>): VideoUploadRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoUploadRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoUploadRequest): VideoUploadRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: VideoUploadRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoUploadRequest
 */
export const VideoUploadRequest = new VideoUploadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoUploadResponse$Type extends MessageType<VideoUploadResponse> {
    constructor() {
        super("brandguard.video.VideoUploadResponse", [
            { no: 1, name: "media", kind: "message", T: () => VideoMedia },
            { no: 2, name: "event", kind: "message", T: () => VideoEvent }
        ]);
    }
    create(value?: PartialMessage<VideoUploadResponse>): VideoUploadResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoUploadResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoUploadResponse): VideoUploadResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.video.VideoMedia media */ 1:
                    message.media = VideoMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* brandguard.video.VideoEvent event */ 2:
                    message.event = VideoEvent.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoUploadResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.video.VideoMedia media = 1; */
        if (message.media)
            VideoMedia.internalBinaryWrite(message.media, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.video.VideoEvent event = 2; */
        if (message.event)
            VideoEvent.internalBinaryWrite(message.event, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoUploadResponse
 */
export const VideoUploadResponse = new VideoUploadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoMediaUploadRequest$Type extends MessageType<VideoMediaUploadRequest> {
    constructor() {
        super("brandguard.video.VideoMediaUploadRequest", [
            { no: 1, name: "md5s", kind: "scalar", localName: "md5s", jsonName: "md5s", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "observation", kind: "enum", T: () => ["brandguard.approval.Prediction", Prediction] },
            { no: 3, name: "delay", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<VideoMediaUploadRequest>): VideoMediaUploadRequest {
        const message = { md5s: [], observation: 0, delay: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoMediaUploadRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoMediaUploadRequest): VideoMediaUploadRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string md5s = 1 [json_name = "md5s"];*/ 1:
                    message.md5s.push(reader.string());
                    break;
                case /* brandguard.approval.Prediction observation */ 2:
                    message.observation = reader.int32();
                    break;
                case /* int64 delay */ 3:
                    message.delay = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoMediaUploadRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string md5s = 1 [json_name = "md5s"]; */
        for (let i = 0; i < message.md5s.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.md5s[i]);
        /* brandguard.approval.Prediction observation = 2; */
        if (message.observation !== 0)
            writer.tag(2, WireType.Varint).int32(message.observation);
        /* int64 delay = 3; */
        if (message.delay !== 0n)
            writer.tag(3, WireType.Varint).int64(message.delay);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoMediaUploadRequest
 */
export const VideoMediaUploadRequest = new VideoMediaUploadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoMediaUploadResponse$Type extends MessageType<VideoMediaUploadResponse> {
    constructor() {
        super("brandguard.video.VideoMediaUploadResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VideoUploadResponse }
        ]);
    }
    create(value?: PartialMessage<VideoMediaUploadResponse>): VideoMediaUploadResponse {
        const message = { items: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoMediaUploadResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoMediaUploadResponse): VideoMediaUploadResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguard.video.VideoUploadResponse items */ 1:
                    message.items.push(VideoUploadResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoMediaUploadResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguard.video.VideoUploadResponse items = 1; */
        for (let i = 0; i < message.items.length; i++)
            VideoUploadResponse.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoMediaUploadResponse
 */
export const VideoMediaUploadResponse = new VideoMediaUploadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoSearchRequest$Type extends MessageType<VideoSearchRequest> {
    constructor() {
        super("brandguard.video.VideoSearchRequest", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "queues", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "deprecated_uploaded_by", kind: "scalar", localName: "deprecated_uploaded_by", jsonName: "uploaded_by", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created", kind: "message", T: () => DateRange },
            { no: 6, name: "limit", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "observation", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["brandguard.approval.Prediction", Prediction] },
            { no: 8, name: "approved", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["brandguard.approval.Prediction", Prediction] },
            { no: 9, name: "confidence", kind: "message", T: () => FloatRange },
            { no: 10, name: "uploaded_by", kind: "scalar", localName: "uploaded_by", jsonName: "uploaders", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "before", kind: "message", T: () => Keyset }
        ]);
    }
    create(value?: PartialMessage<VideoSearchRequest>): VideoSearchRequest {
        const message = { offset: 0n, queues: [], deprecated_uploaded_by: "", brand_id: "", limit: 0n, observation: [], approved: [], uploaded_by: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoSearchRequest): VideoSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* repeated string queues */ 2:
                    message.queues.push(reader.string());
                    break;
                case /* string deprecated_uploaded_by = 3 [deprecated = true, json_name = "uploaded_by"];*/ 3:
                    message.deprecated_uploaded_by = reader.string();
                    break;
                case /* string brand_id = 4 [json_name = "brand_id"];*/ 4:
                    message.brand_id = reader.string();
                    break;
                case /* meta.DateRange created */ 5:
                    message.created = DateRange.internalBinaryRead(reader, reader.uint32(), options, message.created);
                    break;
                case /* uint64 limit */ 6:
                    message.limit = reader.uint64().toBigInt();
                    break;
                case /* repeated brandguard.approval.Prediction observation */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.observation.push(reader.int32());
                    else
                        message.observation.push(reader.int32());
                    break;
                case /* repeated brandguard.approval.Prediction approved */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.approved.push(reader.int32());
                    else
                        message.approved.push(reader.int32());
                    break;
                case /* meta.FloatRange confidence */ 9:
                    message.confidence = FloatRange.internalBinaryRead(reader, reader.uint32(), options, message.confidence);
                    break;
                case /* repeated string uploaded_by = 10 [json_name = "uploaders"];*/ 10:
                    message.uploaded_by.push(reader.string());
                    break;
                case /* meta.Keyset before */ 11:
                    message.before = Keyset.internalBinaryRead(reader, reader.uint32(), options, message.before);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).int64(message.offset);
        /* repeated string queues = 2; */
        for (let i = 0; i < message.queues.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.queues[i]);
        /* string deprecated_uploaded_by = 3 [deprecated = true, json_name = "uploaded_by"]; */
        if (message.deprecated_uploaded_by !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.deprecated_uploaded_by);
        /* string brand_id = 4 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.brand_id);
        /* meta.DateRange created = 5; */
        if (message.created)
            DateRange.internalBinaryWrite(message.created, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* uint64 limit = 6; */
        if (message.limit !== 0n)
            writer.tag(6, WireType.Varint).uint64(message.limit);
        /* repeated brandguard.approval.Prediction observation = 7; */
        if (message.observation.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.observation.length; i++)
                writer.int32(message.observation[i]);
            writer.join();
        }
        /* repeated brandguard.approval.Prediction approved = 8; */
        if (message.approved.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.approved.length; i++)
                writer.int32(message.approved[i]);
            writer.join();
        }
        /* meta.FloatRange confidence = 9; */
        if (message.confidence)
            FloatRange.internalBinaryWrite(message.confidence, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated string uploaded_by = 10 [json_name = "uploaders"]; */
        for (let i = 0; i < message.uploaded_by.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.uploaded_by[i]);
        /* meta.Keyset before = 11; */
        if (message.before)
            Keyset.internalBinaryWrite(message.before, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoSearchRequest
 */
export const VideoSearchRequest = new VideoSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoSearchResponseItem$Type extends MessageType<VideoSearchResponseItem> {
    constructor() {
        super("brandguard.video.VideoSearchResponseItem", [
            { no: 1, name: "media", kind: "message", T: () => VideoMedia },
            { no: 2, name: "event", kind: "message", T: () => VideoEvent }
        ]);
    }
    create(value?: PartialMessage<VideoSearchResponseItem>): VideoSearchResponseItem {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoSearchResponseItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoSearchResponseItem): VideoSearchResponseItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.video.VideoMedia media */ 1:
                    message.media = VideoMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* brandguard.video.VideoEvent event */ 2:
                    message.event = VideoEvent.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoSearchResponseItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.video.VideoMedia media = 1; */
        if (message.media)
            VideoMedia.internalBinaryWrite(message.media, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.video.VideoEvent event = 2; */
        if (message.event)
            VideoEvent.internalBinaryWrite(message.event, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoSearchResponseItem
 */
export const VideoSearchResponseItem = new VideoSearchResponseItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoSearchResponse$Type extends MessageType<VideoSearchResponse> {
    constructor() {
        super("brandguard.video.VideoSearchResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VideoSearchResponseItem },
            { no: 2, name: "next", kind: "message", T: () => VideoSearchRequest }
        ]);
    }
    create(value?: PartialMessage<VideoSearchResponse>): VideoSearchResponse {
        const message = { items: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoSearchResponse): VideoSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguard.video.VideoSearchResponseItem items */ 1:
                    message.items.push(VideoSearchResponseItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* brandguard.video.VideoSearchRequest next */ 2:
                    message.next = VideoSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.next);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguard.video.VideoSearchResponseItem items = 1; */
        for (let i = 0; i < message.items.length; i++)
            VideoSearchResponseItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.video.VideoSearchRequest next = 2; */
        if (message.next)
            VideoSearchRequest.internalBinaryWrite(message.next, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoSearchResponse
 */
export const VideoSearchResponse = new VideoSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoFindRequest$Type extends MessageType<VideoFindRequest> {
    constructor() {
        super("brandguard.video.VideoFindRequest", []);
    }
    create(value?: PartialMessage<VideoFindRequest>): VideoFindRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoFindRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoFindRequest): VideoFindRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: VideoFindRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoFindRequest
 */
export const VideoFindRequest = new VideoFindRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoFindResponse$Type extends MessageType<VideoFindResponse> {
    constructor() {
        super("brandguard.video.VideoFindResponse", [
            { no: 1, name: "media", kind: "message", T: () => VideoMedia },
            { no: 2, name: "event", kind: "message", T: () => VideoEvent }
        ]);
    }
    create(value?: PartialMessage<VideoFindResponse>): VideoFindResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoFindResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoFindResponse): VideoFindResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.video.VideoMedia media */ 1:
                    message.media = VideoMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* brandguard.video.VideoEvent event */ 2:
                    message.event = VideoEvent.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoFindResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.video.VideoMedia media = 1; */
        if (message.media)
            VideoMedia.internalBinaryWrite(message.media, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.video.VideoEvent event = 2; */
        if (message.event)
            VideoEvent.internalBinaryWrite(message.event, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoFindResponse
 */
export const VideoFindResponse = new VideoFindResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoScoreRequest$Type extends MessageType<VideoScoreRequest> {
    constructor() {
        super("brandguard.video.VideoScoreRequest", []);
    }
    create(value?: PartialMessage<VideoScoreRequest>): VideoScoreRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoScoreRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoScoreRequest): VideoScoreRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: VideoScoreRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoScoreRequest
 */
export const VideoScoreRequest = new VideoScoreRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoScoreResponse$Type extends MessageType<VideoScoreResponse> {
    constructor() {
        super("brandguard.video.VideoScoreResponse", []);
    }
    create(value?: PartialMessage<VideoScoreResponse>): VideoScoreResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoScoreResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoScoreResponse): VideoScoreResponse {
        return target ?? this.create();
    }
    internalBinaryWrite(message: VideoScoreResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoScoreResponse
 */
export const VideoScoreResponse = new VideoScoreResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoPatchRequest$Type extends MessageType<VideoPatchRequest> {
    constructor() {
        super("brandguard.video.VideoPatchRequest", [
            { no: 1, name: "media", kind: "message", T: () => VideoMedia },
            { no: 2, name: "event", kind: "message", T: () => VideoEvent }
        ]);
    }
    create(value?: PartialMessage<VideoPatchRequest>): VideoPatchRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoPatchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoPatchRequest): VideoPatchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.video.VideoMedia media */ 1:
                    message.media = VideoMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* brandguard.video.VideoEvent event */ 2:
                    message.event = VideoEvent.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoPatchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.video.VideoMedia media = 1; */
        if (message.media)
            VideoMedia.internalBinaryWrite(message.media, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.video.VideoEvent event = 2; */
        if (message.event)
            VideoEvent.internalBinaryWrite(message.event, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoPatchRequest
 */
export const VideoPatchRequest = new VideoPatchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoPatchResponse$Type extends MessageType<VideoPatchResponse> {
    constructor() {
        super("brandguard.video.VideoPatchResponse", [
            { no: 1, name: "media", kind: "message", T: () => VideoMedia },
            { no: 2, name: "event", kind: "message", T: () => VideoEvent }
        ]);
    }
    create(value?: PartialMessage<VideoPatchResponse>): VideoPatchResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoPatchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoPatchResponse): VideoPatchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.video.VideoMedia media */ 1:
                    message.media = VideoMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* brandguard.video.VideoEvent event */ 2:
                    message.event = VideoEvent.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoPatchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.video.VideoMedia media = 1; */
        if (message.media)
            VideoMedia.internalBinaryWrite(message.media, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.video.VideoEvent event = 2; */
        if (message.event)
            VideoEvent.internalBinaryWrite(message.event, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoPatchResponse
 */
export const VideoPatchResponse = new VideoPatchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoTrainRequest$Type extends MessageType<VideoTrainRequest> {
    constructor() {
        super("brandguard.video.VideoTrainRequest", [
            { no: 1, name: "ago", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<VideoTrainRequest>): VideoTrainRequest {
        const message = { ago: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoTrainRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoTrainRequest): VideoTrainRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 ago */ 1:
                    message.ago = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoTrainRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 ago = 1; */
        if (message.ago !== 0n)
            writer.tag(1, WireType.Varint).int64(message.ago);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoTrainRequest
 */
export const VideoTrainRequest = new VideoTrainRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoTrainResponse$Type extends MessageType<VideoTrainResponse> {
    constructor() {
        super("brandguard.video.VideoTrainResponse", []);
    }
    create(value?: PartialMessage<VideoTrainResponse>): VideoTrainResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoTrainResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoTrainResponse): VideoTrainResponse {
        return target ?? this.create();
    }
    internalBinaryWrite(message: VideoTrainResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoTrainResponse
 */
export const VideoTrainResponse = new VideoTrainResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelSearchRequest$Type extends MessageType<VideoKernelSearchRequest> {
    constructor() {
        super("brandguard.video.VideoKernelSearchRequest", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created", kind: "message", T: () => DateRange },
            { no: 6, name: "limit", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<VideoKernelSearchRequest>): VideoKernelSearchRequest {
        const message = { offset: 0n, brand_id: "", limit: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelSearchRequest): VideoKernelSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* string brand_id = 4 [json_name = "brand_id"];*/ 4:
                    message.brand_id = reader.string();
                    break;
                case /* meta.DateRange created */ 5:
                    message.created = DateRange.internalBinaryRead(reader, reader.uint32(), options, message.created);
                    break;
                case /* uint64 limit */ 6:
                    message.limit = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).int64(message.offset);
        /* string brand_id = 4 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.brand_id);
        /* meta.DateRange created = 5; */
        if (message.created)
            DateRange.internalBinaryWrite(message.created, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* uint64 limit = 6; */
        if (message.limit !== 0n)
            writer.tag(6, WireType.Varint).uint64(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoKernelSearchRequest
 */
export const VideoKernelSearchRequest = new VideoKernelSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelSearchResponse$Type extends MessageType<VideoKernelSearchResponse> {
    constructor() {
        super("brandguard.video.VideoKernelSearchResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => KernelMetadata },
            { no: 2, name: "next", kind: "message", T: () => VideoKernelSearchRequest }
        ]);
    }
    create(value?: PartialMessage<VideoKernelSearchResponse>): VideoKernelSearchResponse {
        const message = { items: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelSearchResponse): VideoKernelSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguard.kernel.KernelMetadata items */ 1:
                    message.items.push(KernelMetadata.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* brandguard.video.VideoKernelSearchRequest next */ 2:
                    message.next = VideoKernelSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.next);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguard.kernel.KernelMetadata items = 1; */
        for (let i = 0; i < message.items.length; i++)
            KernelMetadata.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.video.VideoKernelSearchRequest next = 2; */
        if (message.next)
            VideoKernelSearchRequest.internalBinaryWrite(message.next, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoKernelSearchResponse
 */
export const VideoKernelSearchResponse = new VideoKernelSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelFindRequest$Type extends MessageType<VideoKernelFindRequest> {
    constructor() {
        super("brandguard.video.VideoKernelFindRequest", []);
    }
    create(value?: PartialMessage<VideoKernelFindRequest>): VideoKernelFindRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelFindRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelFindRequest): VideoKernelFindRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: VideoKernelFindRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoKernelFindRequest
 */
export const VideoKernelFindRequest = new VideoKernelFindRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelFindResponse$Type extends MessageType<VideoKernelFindResponse> {
    constructor() {
        super("brandguard.video.VideoKernelFindResponse", [
            { no: 1, name: "kernel", kind: "message", T: () => KernelMetadata }
        ]);
    }
    create(value?: PartialMessage<VideoKernelFindResponse>): VideoKernelFindResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelFindResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelFindResponse): VideoKernelFindResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.kernel.KernelMetadata kernel */ 1:
                    message.kernel = KernelMetadata.internalBinaryRead(reader, reader.uint32(), options, message.kernel);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelFindResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.kernel.KernelMetadata kernel = 1; */
        if (message.kernel)
            KernelMetadata.internalBinaryWrite(message.kernel, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoKernelFindResponse
 */
export const VideoKernelFindResponse = new VideoKernelFindResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelSettingsCreateRequest$Type extends MessageType<VideoKernelSettingsCreateRequest> {
    constructor() {
        super("brandguard.video.VideoKernelSettingsCreateRequest", [
            { no: 1, name: "settings", kind: "message", T: () => VideoKernelSetting }
        ]);
    }
    create(value?: PartialMessage<VideoKernelSettingsCreateRequest>): VideoKernelSettingsCreateRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelSettingsCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelSettingsCreateRequest): VideoKernelSettingsCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.kernel.VideoKernelSetting settings */ 1:
                    message.settings = VideoKernelSetting.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelSettingsCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.kernel.VideoKernelSetting settings = 1; */
        if (message.settings)
            VideoKernelSetting.internalBinaryWrite(message.settings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoKernelSettingsCreateRequest
 */
export const VideoKernelSettingsCreateRequest = new VideoKernelSettingsCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelSettingsCreateResponse$Type extends MessageType<VideoKernelSettingsCreateResponse> {
    constructor() {
        super("brandguard.video.VideoKernelSettingsCreateResponse", [
            { no: 1, name: "kernel", kind: "message", T: () => KernelMetadata }
        ]);
    }
    create(value?: PartialMessage<VideoKernelSettingsCreateResponse>): VideoKernelSettingsCreateResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelSettingsCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelSettingsCreateResponse): VideoKernelSettingsCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.kernel.KernelMetadata kernel */ 1:
                    message.kernel = KernelMetadata.internalBinaryRead(reader, reader.uint32(), options, message.kernel);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelSettingsCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.kernel.KernelMetadata kernel = 1; */
        if (message.kernel)
            KernelMetadata.internalBinaryWrite(message.kernel, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoKernelSettingsCreateResponse
 */
export const VideoKernelSettingsCreateResponse = new VideoKernelSettingsCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelSettingsRequest$Type extends MessageType<VideoKernelSettingsRequest> {
    constructor() {
        super("brandguard.video.VideoKernelSettingsRequest", []);
    }
    create(value?: PartialMessage<VideoKernelSettingsRequest>): VideoKernelSettingsRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelSettingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelSettingsRequest): VideoKernelSettingsRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: VideoKernelSettingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoKernelSettingsRequest
 */
export const VideoKernelSettingsRequest = new VideoKernelSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoKernelSettingsResponse$Type extends MessageType<VideoKernelSettingsResponse> {
    constructor() {
        super("brandguard.video.VideoKernelSettingsResponse", [
            { no: 1, name: "settings", kind: "message", T: () => VideoKernelSetting }
        ]);
    }
    create(value?: PartialMessage<VideoKernelSettingsResponse>): VideoKernelSettingsResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoKernelSettingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoKernelSettingsResponse): VideoKernelSettingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.kernel.VideoKernelSetting settings */ 1:
                    message.settings = VideoKernelSetting.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoKernelSettingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.kernel.VideoKernelSetting settings = 1; */
        if (message.settings)
            VideoKernelSetting.internalBinaryWrite(message.settings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoKernelSettingsResponse
 */
export const VideoKernelSettingsResponse = new VideoKernelSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoRescoreRequest$Type extends MessageType<VideoRescoreRequest> {
    constructor() {
        super("brandguard.video.VideoRescoreRequest", [
            { no: 1, name: "delay", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "window", kind: "message", T: () => DateRange }
        ]);
    }
    create(value?: PartialMessage<VideoRescoreRequest>): VideoRescoreRequest {
        const message = { delay: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoRescoreRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoRescoreRequest): VideoRescoreRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 delay */ 1:
                    message.delay = reader.int64().toBigInt();
                    break;
                case /* meta.DateRange window */ 2:
                    message.window = DateRange.internalBinaryRead(reader, reader.uint32(), options, message.window);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoRescoreRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 delay = 1; */
        if (message.delay !== 0n)
            writer.tag(1, WireType.Varint).int64(message.delay);
        /* meta.DateRange window = 2; */
        if (message.window)
            DateRange.internalBinaryWrite(message.window, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoRescoreRequest
 */
export const VideoRescoreRequest = new VideoRescoreRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoRescoreResponse$Type extends MessageType<VideoRescoreResponse> {
    constructor() {
        super("brandguard.video.VideoRescoreResponse", []);
    }
    create(value?: PartialMessage<VideoRescoreResponse>): VideoRescoreResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoRescoreResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoRescoreResponse): VideoRescoreResponse {
        return target ?? this.create();
    }
    internalBinaryWrite(message: VideoRescoreResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoRescoreResponse
 */
export const VideoRescoreResponse = new VideoRescoreResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoVersionHistoryRequest$Type extends MessageType<VideoVersionHistoryRequest> {
    constructor() {
        super("brandguard.video.VideoVersionHistoryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VideoVersionHistoryRequest>): VideoVersionHistoryRequest {
        const message = { id: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoVersionHistoryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoVersionHistoryRequest): VideoVersionHistoryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoVersionHistoryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoVersionHistoryRequest
 */
export const VideoVersionHistoryRequest = new VideoVersionHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VideoVersionHistoryResponse$Type extends MessageType<VideoVersionHistoryResponse> {
    constructor() {
        super("brandguard.video.VideoVersionHistoryResponse", [
            { no: 1, name: "versions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => VideoSearchResponseItem }
        ]);
    }
    create(value?: PartialMessage<VideoVersionHistoryResponse>): VideoVersionHistoryResponse {
        const message = { versions: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<VideoVersionHistoryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VideoVersionHistoryResponse): VideoVersionHistoryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguard.video.VideoSearchResponseItem versions */ 1:
                    message.versions.push(VideoSearchResponseItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VideoVersionHistoryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguard.video.VideoSearchResponseItem versions = 1; */
        for (let i = 0; i < message.versions.length; i++)
            VideoSearchResponseItem.internalBinaryWrite(message.versions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.video.VideoVersionHistoryResponse
 */
export const VideoVersionHistoryResponse = new VideoVersionHistoryResponse$Type();
